// extracted by mini-css-extract-plugin
module.exports = {"root":"LandingPage_root__1zqkO"};